/**
 *
 * Tenta converter uma string para número, booleano.
 * caso não consiga retorna a string
 */

import { FormFieldTypes } from '../../components/form_components/form';

const parser = (
  value: string,
  type: FormFieldTypes
): number | string | boolean | undefined | null => {
  if (!value && value !== '0' && value !== '') return undefined;

  switch (type) {
    case 'text':
    case 'date':
    case 'time':
    case 'email':
    case 'url':
    case 'tel':
      return value;
    case 'number':
      return parseFloat(value);
    case 'checkbox':
      return value === 'true';
  }
  return value;
};

export { parser };
